import { TicketAddPage } from "./../tickets/add/add";
import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ModalController,
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../providers/wh/summary-service";
import { WaybillOrderServiceProvider } from "../../../providers/qdb/qdb-service";
import { ChangeTimingCpModalComponent } from "./change-timing-cp-modal/change-timing-cp-modal";
import { ChangeBasicInfoCpModalComponent } from "./edit-cp-basic-info/edit-cp-basic-info-modal";
import { DatePipe } from "@angular/common";
import { ChangeUserInfoCpModalComponent } from "./edit-cp-user-info/edit-cp-user-info-modal";
import { ListCPUsersModalComponent } from "./list-cp-users-modal/list-cp-users-modal";
import { ListRTODaysModalComponent } from "./list-rto-days-modal/list-rto-days-modal";
import { ChangeNationalAddressInfoCpModalComponent } from "./edit-cp-national-address-info/edit-cp-national-address-info-modal";

@Component({
  selector: "collection-point-page",
  templateUrl: "index.html",
  providers: [SummaryServiceProvider, WaybillOrderServiceProvider],
})
export class CollectionPointPage {
  header_data: any;

  public site_id: any;
  public cp_data_obj: any;
  public createTicketPage: any;
  statusButtonText;

  cp_data: any = "";

  objectKeys = Object.keys;
  wrongSiteId: any;
  currency: any;
  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public waybillOrderService: WaybillOrderServiceProvider,
    private alertCtrl: AlertController,
    public datepipe: DatePipe,
    public navParams: NavParams,
    public summaryService: SummaryServiceProvider,
    public loadingCtrl: LoadingController
  ) {
    this.header_data = {
      ismenu: true,
      ishome: false,
      title: "Collection Points",
      parentReloadData: (d) => {
        this.load_cp_data(true);
      },
    };
    let userInfo = JSON.parse(localStorage.getItem("userInfoData"));
    if (userInfo) {
      this.currency = userInfo.currency;
    }
    if (this.navParams.get("site_id")) {
      this.site_id = this.navParams.get("site_id");
      this.load_cp_data(true);
    }

    this.createTicketPage = TicketAddPage;
  }

  load_cp_data(show_loader) {
    this.wrongSiteId = false;
    let q: any = "";
    this.cp_data_obj = [];
    this.cp_data = "";

    if (this.site_id !== "") {
      q += "siteId=" + this.site_id;
    }

    if (show_loader) {
      let loader = this.loadingCtrl.create({
        content: "Please wait...",
      });
      loader.present();

      this.summaryService.load_cp_data(q).then((data: any) => {
        this.cp_data = data;
        if (this.cp_data.data.content.length == 1) {
          this.cp_data_obj = this.cp_data.data.content[0];
          if (this.cp_data_obj.status == "ACTIVE") {
            this.statusButtonText = "Deactivate";
          } else {
            this.statusButtonText = "Activate";
          }
        } else {
          this.wrongSiteId = true;
        }
      });

      loader.dismiss();
    } else {
      this.summaryService.load_tickets_data(q).then((data) => {
        this.cp_data = data;
        this.cp_data_obj = this.cp_data.data.content[0];
      });
    }
  }
  load_cp_data_details(id, show_loader) {
    this.wrongSiteId = false;
    this.cp_data_obj = [];
    this.cp_data = "";

    if (show_loader) {
      let loader = this.loadingCtrl.create({
        content: "Please wait...",
      });
      loader.present();

      this.summaryService.load_cp_data_details(id).then((data: any) => {
        this.cp_data = data;
        if (this.cp_data.code == 1001) {
          this.cp_data_obj = this.cp_data.data;
          if (this.cp_data_obj.status == "ACTIVE") {
            this.statusButtonText = "Deactivate";
          } else {
            this.statusButtonText = "Activate";
          }
        } else {
          this.wrongSiteId = true;
        }
      });
      loader.dismiss();
    }
  }

  confirmStatusChange(id, currentStatus) {
    var updateStatus = "";
    var message = "";
    if (currentStatus == "ACTIVE") {
      updateStatus = "NOT_ACTIVE";
      message = "Do you want to deactivate this Site?";
    } else if (currentStatus == "NOT_ACTIVE") {
      updateStatus = "ACTIVE";
      message = "Do you want to activate this Site?";
    }
    let alert = this.alertCtrl.create({
      title: "Confirm",
      message: `${message}`,
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          },
        },
        {
          text: "Yes",
          handler: () => {
            var payload = {
              status: updateStatus,
            };
            this.waybillOrderService
              .patchCPStatusChange(
                `/api/v0.2/techsupport/collectionpoints/${id}`,
                payload
              )
              .then((res) => {
                this.load_cp_data_details(id, true);
              });
          },
        },
      ],
    });
    alert.present();
  }

  changeTimingModal(data) {
    const modal = this.modalCtrl.create(ChangeTimingCpModalComponent, {
      data: data,
    });
    modal.onDidDismiss((value) => {
      if (value) {
        this.load_cp_data_details(data.id, value);
      }
    });
    modal.present();
  }

  setRTODays(data) {
    const modal = this.modalCtrl.create(ListRTODaysModalComponent, {
      data: data,
    });
    modal.onDidDismiss((value) => {
      if (value) {
        this.load_cp_data_details(data.id, value);
      }
    });
    modal.present();
  }

  changeBasicInfoModal(data) {
    const modal = this.modalCtrl.create(ChangeBasicInfoCpModalComponent, {
      data: data,
    });
    modal.onDidDismiss((value) => {
      if (value) {
        this.load_cp_data_details(data.id, value);
      }
    });
    modal.present();
  }

  changeNationalAddressInfoModal(data) {
    const modal = this.modalCtrl.create(ChangeNationalAddressInfoCpModalComponent, {
      data: data,
    });
    modal.onDidDismiss((value) => {
      if (value) {
        this.load_cp_data_details(data.id, value);
      }
    });
    modal.present();
  }

  listUserInfoModal(data) {
    const modal = this.modalCtrl.create(ListCPUsersModalComponent, {
      data: data,
    });
    modal.onDidDismiss((value) => {
      if (value) {
        this.load_cp_data_details(data.id, value);
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/index.ts